import TableCell, { TableCellProps } from "@mui/material/TableCell";

interface Props extends TableCellProps {}

export const TableCellHeader = (props: Props) => {
  return (
    <TableCell {...props} sx={{ fontSize: 16, fontWeight: 500 }}>
      {props.children}
    </TableCell>
  );
};

export const TableCellRow = (props: Props) => {
  return (
    <TableCell {...props} sx={{ fontSize: 14, fontWeight: 500 }}>
      {props.children}
    </TableCell>
  );
};
